import { render } from "./AdminNavbar.vue?vue&type=template&id=6704cb9a"
import script from "./AdminNavbar.vue?vue&type=script&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__